import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import { ComplianceCheckInDto } from 'shared/dtos/in/complianceCheck';
import { DocumentInDto } from 'shared/dtos/in/document';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import { ProtocolItemInDto } from 'shared/dtos/in/protocolItem';
import {
  complianceResultFromProtocolAnswers,
  getProtocolItemEkComment,
} from 'shared/domain/inspection/protocolItemAccessors';

function normalizeProtocolAnswerInDto(answer: ProtocolAnswerInDto): ProtocolAnswerInDto {
  return {
    ...answer,
    isApplicable: answer.isApplicable ?? true,
  };
}

/**
 * Ingress adapter: unifies PT-6687 API (answers + top-level comment/documents)
 * with legacy complianceCheck so downstream model, IDB, and UI paths stay consistent.
 */
export function normalizeProtocolItemInDto(
  protocol: ProtocolItemInDto
): ProtocolItemInDto {
  const answers = (protocol.answers ?? []).map(normalizeProtocolAnswerInDto);
  const legacyCompliance = protocol.complianceCheck;

  const comment = getProtocolItemEkComment({
    comment: protocol.comment,
    complianceCheck: legacyCompliance,
  });
  const documents: DocumentInDto[] =
    protocol.documents ?? legacyCompliance?.documents ?? [];
  const issues = legacyCompliance?.issues ?? [];
  const result =
    legacyCompliance?.result ?? complianceResultFromProtocolAnswers(answers);

  const complianceCheck: ComplianceCheckInDto = {
    comment,
    documents,
    issues,
    result,
  };

  return {
    ...protocol,
    answers,
    comment,
    complianceCheck,
  };
}
